import { useEffect, useRef, useState } from "react";
import PrimaryButton from "./PrimaryButton";
import classes from "./ButtonDropdown.module.css";
import LinkButton from "./LinkButton";
import dropDownIcon from "../../assets/icons/drop-down.svg";

interface Props {
  name: string;
  options: any[];
  disabled?: boolean;
  onClick: (value: any) => void;
}

const ButtonDropdown: React.FC<Props> = ({
  name,
  options,
  disabled = false,
  onClick,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const optionsRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  const [canOpen, setCanOpen] = useState(false);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current?.contains(event.target as Node)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    const handleResize = () => {
      if (optionsRef.current) {
        const buttonRect = optionsRef.current.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const spaceOnRight = windowWidth - buttonRect.right;
        setCanOpen(spaceOnRight > 0);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={classes.main} ref={ref}>
      <PrimaryButton
        className={classes.button}
        name={name}
        onClick={() => setShow((e) => !e)}
        rightIcon={
          <img className={classes.arrowDown} src={dropDownIcon} alt='' />
        }
        disabled={disabled}
      />
      {show && (
        <div
          className={classes.options}
          style={canOpen ? {} : { right: 0 }}
          ref={optionsRef}>
          {options.map((btn, idx) => (
            <LinkButton
              key={idx}
              className={classes.option}
              label={btn.name || btn || ""}
              onClick={() => {
                onClick(btn.value || btn);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ButtonDropdown;
